// Blocks
import { BarBlock } from './bar/bar-block'
import { ForestBlock } from './forest/forest-block'
import { ImageBlock } from './image/image-block'
import { LineBlock } from './line/line-block'
import { MapBlock } from './map/map-block'
import { MarkdownBlock } from './markdown/markdown-block'
import { SankeyBlock } from './sankey/sankey-block'
import { SummaryBlock } from './summary/summary-block'
import { SunburstBlock } from './sunburst/sunburst-block'
import { TableBlockViewer } from './table/table-block-viewer'
import { TextBlock } from './text/text-block'
import { TitleBlock } from './title/title-block'
import { DescriptionBlock } from './description/description-block'

/**
 * This is used to map between the block 'type' in the page layout definition and the component to render that block
 */
export const blockViewComponents = {
  bar: BarBlock,
  forest: ForestBlock,
  image: ImageBlock,
  line: LineBlock,
  map: MapBlock,
  markdown: MarkdownBlock,
  sankey: SankeyBlock,
  summary: SummaryBlock,
  sunburst: SunburstBlock,
  table: TableBlockViewer,
  text: TextBlock,
  title: TitleBlock,
  description: DescriptionBlock
}
